import FilterCheckboxChip from '../FilterChips/FilterCheckboxChip';
import HealthStatTooltip from '../HealthStatTooltip';
import Stack from '../Stack';
import { getOnChange } from '../SectionTableFilterChips';
import { getSentimentBadgeProps } from '../Post/utils';
import { healthStatFilterOptions } from 'utils/filters';
import styled from 'styled-components';

const sentimentScoreFilter = healthStatFilterOptions.find(
    ({ label }) => label === 'sentiment score',
);
const SentimentFilterChipStack = styled(Stack)`
    color: ${({ $fgColor }) => $fgColor};
`;

function SentimentFilters({ posts, filters, setFilter, css }) {
    const appliedFilters = filters.healthStats
        ? filters.healthStats
              .filter(({ value }) =>
                  sentimentScoreFilter.options.some(
                      ({ value: optionValue }) => value === optionValue,
                  ),
              )
              .map(({ value }) => value)
        : null;
    const counts = posts?.reduce(
        (acc, { sentimentScoreInt }) => {
            if (sentimentScoreInt >= 8) {
                acc.positive++;
            } else if (sentimentScoreInt >= 4) {
                acc.mixed++;
            } else if (sentimentScoreInt > 0 || sentimentScoreInt === 0) {
                acc.negative++;
            }
            return acc;
        },
        {
            positive: 0,
            mixed: 0,
            negative: 0,
        },
    );
    const onChange = getOnChange(
        sentimentScoreFilter.filter,
        filters,
        setFilter,
    );
    return (
        <Stack
            $direction="row"
            $space=".5rem"
            css="display: flex; flex-grow: 1;"
        >
            {sentimentScoreFilter.options.map((option) => {
                const { label, value, score, metricLabel } = option;
                const { Icon, fgColor } = getSentimentBadgeProps(score);
                const checked =
                    !!appliedFilters && appliedFilters.includes(value);
                const count = counts?.[label.toLowerCase()];

                return (
                    <HealthStatTooltip
                        metricLabel={metricLabel}
                        label={label}
                        score={score}
                        key={label}
                    >
                        <FilterCheckboxChip
                            checked={checked}
                            onChange={() =>
                                onChange({
                                    action: checked
                                        ? 'remove-value'
                                        : 'select-option',
                                    option,
                                })
                            }
                            preserveIconSpace={false}
                        >
                            <SentimentFilterChipStack
                                $fgColor={fgColor}
                                $direction="row"
                                as="span"
                                $space="1ch"
                                css="display: inline-flex;"
                            >
                                <span
                                    css={`
                                        display: inline-flex;
                                    `}
                                >
                                    <Icon />
                                </span>
                                <span>
                                    {label}
                                    {count || count === 0 ? (
                                        <span
                                            css={`
                                                margin-left: 0.5em;
                                                color: ${({ theme }) =>
                                                    theme.gray_600};
                                            `}
                                        >
                                            {count}
                                        </span>
                                    ) : null}
                                </span>
                            </SentimentFilterChipStack>
                        </FilterCheckboxChip>
                    </HealthStatTooltip>
                );
            })}
        </Stack>
    );
}

export default SentimentFilters;
